import UnauthedRoute from './UnauthedRoute';

export default UnauthedRoute;
